var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fitty-wrapper"},[_c('div',{staticClass:"fit",attrs:{"id":_vm.fittyId}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }